export const ROLE = {
  NONE: "",
  MANUFRACTURER: "Manufacturer",
  TRANSPORTER: "Transporter",
};
export const AUTH_TOKEN_KEY = "auth_token";
